import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function MissionVision() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Mission & Vision</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Mission & Vision</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Mission & Vision</h1>
                            <div class="card-section">
                                <div class="card">
                                    <h2><i class="fas fa-bullseye"></i> Our Mission</h2>
                                    <p><b>At SMNS, we are dedicated to shaping young minds to thrive in a changing world while staying rooted in strong values. Our mission is to:</b></p>
                                    <ul className="checklist">
                                        <li><b>Nurture curious and independent learners</b> who embrace lifelong learning with confidence.</li>
                                        <li><b>Foster kindness, empathy, and moral integrity</b> in every child.</li>
                                        <li><b>Celebrate the joy of learning and the wonder of life,</b> encouraging respect for self, others, and the world around us.</li>
                                        <li><b>Cultivate responsible citizens</b> who contribute positively to both local and global communities.</li>
                                    </ul>
                                </div>
                                <div class="card">
                                    <h2><i class="fas fa-eye"></i> Our Vision</h2>
                                    <p><b>We envision SMNS as a place where children shine, explore, and grow holistically. Our vision is to:</b></p>
                                    <ul className="checklist">
                                        <li><b>Empower young minds</b> to lead meaningful and fulfilled lives.</li>
                                        <li><b>Ignite creativity and critical thinking</b> through innovative, play-way learning experiences.</li>
                                        <li><b>Build strong social and emotional skills,</b> nurturing collaborative, compassionate individuals.</li>
                                        <li><b>Instill timeless values and character,</b> guiding children to become thoughtful, responsible, and confident citizens of tomorrow.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default MissionVision